import useTranslator from "../../hooks/useTranslator";
import noticIcon from "../../assets/img/noticIcon.svg";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import Twotone from "../../assets/img/Twotone.svg";
import UpdatedIncomeSourceModal from "./UpdateIncomeSourceModal";
import {
  checkSalary,
  convertCurrencyFormat,
  haveValue,
  formatToStandardDate,
} from "../../helper/common";
import { useEffect, useState } from "react";
import moment from "moment";

const DetailsIncomeInfo = (props) => {
  const { user = {}, forensicAnalysis = null, handleInfoModal } = props;
  const { _t } = useTranslator();

  const [recordedSalary, setRecordedSalary] = useState({
    salary: 0,
    matched: 0,
  });

  // const [dataInfoModal, setDataInfoModal] = useState(false);

  useEffect(() => {
    if (haveValue(user)) {
      const temp_sal = checkSalary(user);
      setRecordedSalary(temp_sal);
    }
  }, []);

  return (
    <>
      <div className="main_doc_div mt-3">
        <div className="d-flex align-items-center gap-2 BorderB2">
          <img src={Twotone} alt="Vector Icon" className="vactorImg2" />
          <p className="docheader">{_t("incomeInformation")}</p>
        </div>
        <div className="row">
          <div
            className="col-4"
            style={{ cursor: "pointer" }}
            // onClick={() => setDataInfoModal(true)}
          >
            <div className="Indo_form BorderB2 ">
              <p className="formlabel d-block">{_t("declaredIncome")}</p>
              <p className="placeholderTest">
                €{convertCurrencyFormat(user?.current_annual_income ?? 0)}
              </p>
            </div>
          </div>
          <div className="col-4">
            <div className="Indo_form BorderB2 ">
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("netIncomeFromBank")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {haveValue(
                    user?.kyc_details?.userDataByProvider?.[0]?.providerName
                  ) &&
                    user?.kyc_details?.userDataByProvider?.[0]?.providerName !==
                      "Uploaded from CSV" &&
                    haveValue(recordedSalary?.salary) &&
                    recordedSalary?.salary > 0 && (
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="validationIcon"
                      />
                    )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(recordedSalary?.salary) ? (
                  <div>
                    €
                    {!Number.isNaN(recordedSalary?.salary)
                      ? convertCurrencyFormat(recordedSalary?.salary)
                      : 0}{" "}
                    (
                    {haveValue(recordedSalary?.salary) &&
                      recordedSalary?.salary > 0 &&
                      moment(
                        haveValue(user?.bankVerificationDate)
                          ? user?.bankVerificationDate
                          : user?.created_at
                      ).format("MMM YYYY")}
                    )
                  </div>
                ) : (
                  <div>€0</div>
                )}
              </p>
            </div>
          </div>
          <div className="col-4">
            <div
              className={`Indo_form BorderB2 ${
                haveValue(
                  forensicAnalysis?.["Tax returns"]?.dataInJSON?.combinedIncome
                )
                  ? "cursor-pointer custom-tooltip"
                  : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={(e) => {
                if (
                  haveValue(
                    forensicAnalysis?.["Tax returns"]?.dataInJSON
                      ?.combinedIncome
                  )
                ) {
                  handleInfoModal(forensicAnalysis?.["Tax returns"]);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1 ">
                <p className="formlabel d-block ">
                  {_t("incomeFromTaxReport")}
                </p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.["Tax returns"]?.verifiedSource ===
                  true ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(
                  forensicAnalysis?.["Tax returns"]?.dataInJSON?.combinedIncome
                ) ? (
                  `${
                    forensicAnalysis?.["Tax returns"]?.dataInJSON
                      ?.currencySymbol
                  }${
                    !Number.isNaN(
                      forensicAnalysis?.["Tax returns"]?.dataInJSON
                        ?.combinedIncome
                    ) &&
                    forensicAnalysis?.["Tax returns"]?.dataInJSON
                      ?.combinedIncome > 0
                      ? `${forensicAnalysis?.["Tax returns"]?.dataInJSON?.combinedIncome} (${forensicAnalysis["Tax returns"]?.dataInJSON?.taxReturnYear})`
                      : 0
                  }
                  `
                ) : haveValue(user?.itr_amount) ? (
                  <>{user?.itr_amount}</>
                ) : (
                  <>{_t("notFound")}</>
                )}
              </p>
            </div>
          </div>
        </div>
        {haveValue(forensicAnalysis?.Income?.dataInJSON?.payslips) &&
        forensicAnalysis?.Income?.dataInJSON?.payslips?.length > 0 ? (
          <div className="pb-0 BorderB2">
            <p style={{ lineHeight: "normal" }} className="formlabel d-block">
              {_t("payslips")}
            </p>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          {haveValue(forensicAnalysis?.Income?.dataInJSON?.payslips) ? (
            forensicAnalysis?.Income?.dataInJSON?.payslips
              ?.slice(0, 3)
              .map((data, index) => (
                <>
                  <div
                    className={`col-4 ${
                      haveValue(data) ? "cursor-pointer custom-tooltip" : ""
                    }`}
                    data-tooltip={_t("clickHereToSeeDetails")}
                    onClick={(e) => {
                      if (haveValue(data)) {
                        handleInfoModal(data);
                      }
                    }}
                  >
                    <div className="Indo_form BorderB2 payslip_wrapper">
                      <div className=" d-flex align-items-center gap-1">
                        <p className="placeholderTest my-0">
                          €{data?.netIncome} ({formatToStandardDate(data?.date)}
                          )
                        </p>
                        {forensicAnalysis?.Income?.verifiedSource === true &&
                          data?.verified && (
                            <div className=" d-flex align-items-center gap-1">
                              <img
                                src={CheckIcon0}
                                alt="Vector Icon"
                                className="validationIcon"
                              />
                            </div>
                          )}
                      </div>
                      <p className="placeholderTest converted_text">
                        {data?.originalCurrencySymbol !==
                          data?.salaryCurrencySymbol && `(${_t("converted")})`}
                      </p>
                    </div>
                  </div>
                </>
              ))
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default DetailsIncomeInfo;
